import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/procedimento-individualizado`

    return {
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        create(queryParms) {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id, queryParms) {
            return repository.get(`${baseUrl}/${id}/edit?${urlUtil.serialize(queryParms)}`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id, queryParms) {
            return repository.delete(`${baseUrl}/${id}?${urlUtil.serialize(queryParms)}`)
        },
    }
}